import { apiClient } from '@copro/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { keys } from './keys';

type Command = {
  groupId: string;
  columnId: string;
  visible: boolean;
};

async function updateQuoteColumnVisibility(command: Command) {
  const { error } = await apiClient
    .from('quote_comparison_columns')
    .update({ visible: command.visible })
    .eq('id', command.columnId);

  if (error) {
    throw error;
  }
}

export function useUpdateQuoteColumnVisibility() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateQuoteColumnVisibility,
    onSuccess: (_data, command) => {
      queryClient.invalidateQueries({ queryKey: keys.columns(command.groupId) });
    },
    onError: () => {
      enqueueSnackbar('L\'affichage du critère n\'a pas pu être modifié. Réessayez.', 'error');
    },
  });
}
